<template>
  <div class="card card-custom gutter-b">
    <custom-popup
      v-model="newUserDialog"
      :cons="{ title: $t('widget12.createNewUser') }"
      hide-confirm
    >
      <create-user-form
        :loading="loading"
        :errors="formErrors"
        @create-user="createUser"
        @error="(msg) => $toast.error(msg)"
      />
    </custom-popup>

    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{
          $t("widget12.inviteFriends")
        }}</span>
      </h3>
      <div class="card-toolbar"></div>
    </div>

    <div v-if="!hasNone" class="card-body py-0">
      <v-btn
        class="btn-history rounded-pill align-center d-flex"
        to="/myInvention"
        width="100%"
      >
        {{ $t("widget12.viewInvitedUsers") }}
      </v-btn>

      <div
        v-if="!hasNone"
        class="tengah py-3 d-flex w-100 justify-content-between col-md-11"
      >
        <div class="mr-3 mt-3 pr-3">
          <div class="row">{{ $t("widget12.yourInviteCode") }}</div>
          <CopyButton
            :text="'' + code"
            :title="copyTextTitle"
            :showIcon="showIcon"
            @copy="copyText"
          />
        </div>

        <div class="d-flex" v-status="'user_create'">
          <v-btn
            class="btn-add-with-text ma-0 mt-auto"
            @click="newUserDialog = true"
          >
            <v-icon>mdi-plus</v-icon>
            {{ $t("widget12.createNewUser") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CopyButton from "@/view/content/widgets/CopyButton";
import { mapGetters } from "vuex";
import CreateUserForm from "@/view/pages/admin/users/CreateUserForm.vue";
import i18n from "@/i18n";

export default {
  name: "widget-12",
  i18n,
  components: { CopyButton, CreateUserForm },
  mounted() {
    this.getCode();
  },
  data() {
    return {
      copyTextTitle: this.$t("widget12.copyText"),
      showIcon: false,
      code: null,
      hasNone: false,
      show: "day",

      month: [
        {
          title: "Bestseller Theme",
          desc: "Amazing Templates",
          desc2: "ReactJS, Ruby",
          users: "354 Users",
          img: "media/svg/misc/014-kickstarter.svg",
        },
        {
          title: "Top Authors",
          desc: "Successful Fellas",
          desc2: "ReactJs, HTML",
          users: "4600 Users",
          img: "media/svg/misc/006-plurk.svg",
        },
        {
          title: "New Users",
          desc: "Awesome Users",
          desc2: "Laravel, Metronic",
          users: "890 Users",
          img: "media/svg/misc/003-puzzle.svg",
        },
        {
          title: "Popular Authors",
          desc: "Most Successful",
          desc2: "Python, MySQL",
          users: "7200 Users",
          img: "media/svg/misc/015-telegram.svg",
        },
        {
          title: "Active Customers",
          desc: "Best Customers",
          desc2: "AngularJS, C#",
          users: "6370 Users",
          img: "media/svg/misc/005-bebo.svg",
        },
      ],
      week: [
        {
          title: "Popular Authors",
          desc: "Most Successful",
          desc2: "Python, MySQL",
          users: "7200 Users",
          img: "media/svg/misc/015-telegram.svg",
        },
        {
          title: "Top Authors",
          desc: "Successful Fellas",
          desc2: "ReactJs, HTML",
          users: "4600 Users",
          img: "media/svg/misc/006-plurk.svg",
        },
        {
          title: "New Users",
          desc: "Awesome Users",
          desc2: "Laravel, Metronic",
          users: "890 Users",
          img: "media/svg/misc/003-puzzle.svg",
        },
        {
          title: "Active Customers",
          desc: "Best Customers",
          desc2: "AngularJS, C#",
          users: "6370 Users",
          img: "media/svg/misc/005-bebo.svg",
        },
        {
          title: "Bestseller Theme",
          desc: "Amazing Templates",
          desc2: "ReactJS, Ruby",
          users: "354 Users",
          img: "media/svg/misc/014-kickstarter.svg",
        },
      ],
      day: [
        {
          title: "Popular Authors",
          desc: "Most Successful",
          desc2: "Python, MySQL",
          users: "7200 Users",
          img: "media/svg/misc/015-telegram.svg",
        },
        {
          title: "Top Authors",
          desc: "Successful Fellas",
          desc2: "ReactJs, HTML",
          users: "4600 Users",
          img: "media/svg/misc/006-plurk.svg",
        },
        {
          title: "New Users",
          desc: "Awesome Users",
          desc2: "Laravel, Metronic",
          users: "890 Users",
          img: "media/svg/misc/003-puzzle.svg",
        },
        {
          title: "Bestseller Theme",
          desc: "Amazing Templates",
          desc2: "ReactJS, Ruby",
          users: "354 Users",
          img: "media/svg/misc/014-kickstarter.svg",
        },
        {
          title: "Active Customers",
          desc: "Best Customers",
          desc2: "AngularJS, C#",
          users: "6370 Users",
          img: "media/svg/misc/005-bebo.svg",
        },
      ],
      loading: false,
      newUserDialog: false,
      formErrors: {},
    };
  },
  methods: {
    getCode() {
      this.requestApiGet("myCode")
        .then((response) => {
          this.code = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.hasNone = true;
        });
    },
    createUser(newUser) {
      this.$modal.showLoading();
      this.requestApiPost("admin/user/create", {
        name: newUser.name,
        lastName: newUser.lastName,
        phone: newUser.phone,
        nid: newUser.nid,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.newUserDialog = false;
          this.$toast.success(this.$t("widget12.userCreatedSuccess"));
        })
        .catch(({ response }) => {
          this.formErrors = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    copyText(type) {
      if (navigator) {
        navigator.clipboard.writeText(type);
      }
      this.copyTextTitle = "";
      this.showIcon = true;
    },
  },
  watch: {
    showIcon: function (val) {
      setTimeout(() => {
        this.copyTextTitle = this.$t("widget12.copyText");
        this.showIcon = false;
      }, 2000);
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    subUsers() {
      return [
        {
          userPhone: "09900712365",
          profit: "20000",
          create_date: "1401-11-20",
          type: this.$t("emailSettings.realPerson"),
          lastTransactionDate: "1401-12-02",
        },
        {
          userPhone: "09900712365",
          profit: "9658",
          create_date: "1395-07-29",
          type: this.$t("emailSettings.realPerson"),
          lastTransactionDate: "1399-11-12",
        },
        {
          userPhone: "09100712365",
          profit: "54850",
          create_date: "1399-04-01",
          type: this.$t("emailSettings.legalPerson"),
          lastTransactionDate: "1400-05-02",
        },
        {
          userPhone: "09900712398",
          profit: "1000",
          create_date: "1390-12-14",
          type: this.$t("emailSettings.legalPerson"),
          lastTransactionDate: "1394-12-21",
        },
      ];
    },
    dataToShow() {
      if (this.show === "month") return this.month;
      if (this.show === "week") return this.week;
      if (this.show === "day") return this.day;
      return this.day;
    },
  },
};
</script>
